module.exports = __webpack_public_path__ + "static/colligan-logo-2fb08d87279ed5180cd390d3f852c770.jpg";